<div class="lds-ellipsis">
  <div class="first"></div>
  <div class="second"></div>
  <div class="third"></div>
  <div class="forth"></div>
</div>
